import styled from 'styled-components';

const StyledArrowLink = styled.div`
  a {
    display: flex;
    align-items: center;
    gap: 15px;

    svg {
      transition: transform 0.3s ease;
    }

    .stretched__link {
      position: absolute;
      inset: 0;
      z-index: 5;
    }
    &:hover {
      svg {
        transform: translateX(10px);
      }
    }
  }
`;

export default StyledArrowLink;
